import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pxpb5s3cxg: FaireBrandEntity = {
  token: "b_pxpb5s3cxg",
  type: "brand",
  name: "Gemcohub",
  avatarUrl:
    "https://cdn.faire.com/fastly/a5ef8ae832c6590c4646675d2d9604b7a312a475be120f289232021874327dad.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2cf385da1b49d6a128998f8de79e20f63fa279e01703fcb83ef769d2a9ebff6b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a5ef8ae832c6590c4646675d2d9604b7a312a475be120f289232021874327dad.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2cf385da1b49d6a128998f8de79e20f63fa279e01703fcb83ef769d2a9ebff6b.jpeg",
  location: "HKG",
  minimumOrderDollars: 69,
  rating: 4.7,
  reviewCount: 22,
  isInsider: true,
  description:
    "Welcome to Gemcohub!\n\nOur collection spans a variety of pieces, from classic necklaces and bracelets to modern rings and earrings, each one embodying the beauty and magnificence of gold. Wearing our golden color jewelry is more than just a style statement; it's an experience of luxury and glamour that celebrates individuality and timeless beauty.\n\nWith our dedication to excellence and our commitment to creating high-quality jewelry, we aim to inspire and enchant those who wear our golden color pieces. We are proud to be a part of your story and to accompany every moment with our collection of golden color jewelry.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:54.057Z",
    importedBy: "entity-db-cli",
  },
};
